export default __webpack_public_path__ + "static/media/Dashboard_card2.f9bcb345.png";